<script>
export default {
  name: 'FundsList',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    edit(indexToEdit) {
      this.$emit('fund-edit', indexToEdit);
    },
    remove(indexToRemove) {
      const funds = this.value.filter((_, index) => index !== indexToRemove);

      this.$emit('input', funds);
    },
  },
};
</script>

<template>
  <div>
    <b-list-group :flush="true">
      <b-list-group-item v-for="(item, index) in value" :key="index">
        <div class="row">
          <div class="col-lg-7 text-lg-left text-center">
            <span> Source of Funds: {{ item.source_of_funds }} Amount: {{ item.fund_value }} </span>
          </div>
          <div class="col-lg-5">
            <div class="col-lg-12 text-center text-lg-right">
              <button :id="'edit_fund_' + index" @click="edit(index)" class="btn btn-edit my-1 mx-2" />
              <button :id="'remove_fund_' + index" @click="remove(index)" class="btn btn-remove my-1 mx-2" />
            </div>
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>
